import React from 'react'
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink } from './SidebarElements'

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon> 
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to='about' onClick={toggle}>About</SidebarLink>
          <SidebarLink to='vision' onClick={toggle}>Vision</SidebarLink>
          <SidebarLink to='Mission' onClick={toggle}>Mission</SidebarLink>
          <SidebarLink to='partner' onClick={toggle}>Join Us</SidebarLink>
          {/*<SidebarLink to='intern' onClick={toggle}>Internships</SidebarLink>*/}
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar
